<template>
	<!-- 通用底部 -->
	<footer class="footer">
		<div class="item">
			<span>主办单位：国家开放大学学生工作与教师发展部</span>
			<span>技术支持：国开在线教育科技有限公司</span>
		</div>
		<div class="item">
			<span>地址：北京市海淀区复兴路75号</span>
			<span>邮编：100039</span>
		</div>
	</footer>
</template>

<script>
export default {
	data () {
		return {
			
		}
	},

	computed:{
		
	},
	
	mounted(){
		
	},
	 
	methods:{
	
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.footer{
	 background:#20A2FB; padding:30px 0; text-align: center;
	.item{
		display:inline-block; margin:0 70px; text-align: left;
		span{ display:block;  color:#fff; font-size:20px; line-height:50px;  }
	}
}
</style>



// WEBPACK FOOTER //
// src/components/footer/index.vue